import React from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';

import PasswordTextField from 'components/PasswordTextField/PasswordTextField';
import SplitPageContainer from 'components/SplitPageContainer';
import SplitPageRight from 'components/SplitPageRight';

import withStyles from '@material-ui/core/styles/withStyles';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import grey from '@material-ui/core/colors/grey';

const styles = theme => {
  return {
    header: {
      fontSize: 50,
      lineHeight: 1,
      color: theme.palette.primary.main,
      marginTop: theme.spacing(13),
      marginLeft: -4, // Permanent fix for header being slightly off
      [theme.breakpoints.down('xs')]: {
        fontSize: 30.9,
        marginTop: theme.spacing(2),
      },
    },
    subheader: {
      fontSize: 17,
      lineHeight: 1.41,
      letterSpacing: 0.2,
      marginTop: theme.spacing(1),
      maxWidth: theme.spacing(70),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(4),
      },
    },
    button: {
      fontWeight: 'bold',
      fontSize: 14.6,
      lineHeight: 1.1,
      letterSpacing: 1.3,
      width: 243,
      marginTop: theme.spacing(4),
    },
    inputTwo: {
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    labelSize: {
      fontSize: 25,
      paddingTop: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        fontSize: 20,
        marginTop: theme.spacing(1),
      },
    },
    inputSize: {
      fontSize: 28,
      minHeight: 70,
      paddingTop: theme.spacing(1),
    },
    disabled: {
      borderColor: grey[300],
    },
    passwordMessage: {
      marginTop: theme.spacing(2),
      fontSize: 15,
    },
    root: {
      marginTop: 0,
    },
    helperTextContainer: {
      marginTop: theme.spacing(0.5),
    },
    textfields: {
      width: '60%',
    },
  };
};

class PasswordReset extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    fetchResetTokenValidation: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
    status: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  state = {
    password: '',
    secondPassword: '',
    validPassword: false,
    validToken: false,
  };

  handleSubmit = event => {
    const { resetPassword, location, match } = this.props;
    let { password, secondPassword } = this.state;
    const resetToken = qs.parse(location.search).resetToken;
    const subdomain = match.params.subdomain;
    if (this.checkNewPasswordCriteria()) {
      resetPassword(password, secondPassword, resetToken, subdomain);
    }
    event.preventDefault();
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.status.isLoading() &&
      this.props.status.isNormal() &&
      this.checkNewPasswordCriteria()
    ) {
      window.location.href = '/';
    }
    if (prevProps.status.isLoading() && this.props.status.isNormal()) {
      this.setState({ validToken: true });
    }
    if (prevProps.status.isLoading() && this.props.status.hasError()) {
      window.location.href = '/';
    }
  }

  componentDidMount() {
    const { fetchResetTokenValidation, location, match } = this.props;
    const query = qs.parse(location.search);
    const subdomain = match.params.subdomain;
    fetchResetTokenValidation(query.resetToken, subdomain);
  }

  handleChangeTwo = event => {
    this.setState({ secondPassword: event.target.value });
  };

  setValidPasswordCallback = validPassword => {
    this.setState({ validPassword: validPassword });
  };

  setPasswordCallback = password => {
    this.setState({ password: password });
  };

  submitResetPassword = () => {
    const { resetPassword, location, match } = this.props;
    let { password, secondPassword } = this.state;
    const resetToken = qs.parse(location.search).resetToken;
    const subdomain = match.params.subdomain;
    resetPassword(password, secondPassword, resetToken, subdomain);
  };

  checkPasswordsMatch = () => {
    let { password, secondPassword } = this.state;
    if (secondPassword.length !== 0 && password !== secondPassword) {
      return 'Passwords do not match.';
    } else {
      return <br />;
    }
  };

  checkNewPasswordCriteria = () => {
    return this.state.validPassword && this.state.password === this.state.secondPassword;
  };

  render() {
    const { classes } = this.props;
    if (!this.state.validToken) {
      return null;
    }
    return (
      <SplitPageContainer>
        <SplitPageRight>
          <Typography className={classes.header} variant="h2">
            Reset Your Password
          </Typography>
          <Typography className={classes.subheader} variant="body1">
            Enter a new password. Passwords must be at least 8 characters long and include at least
            one lowercase letter, one uppercase letter, and one number.
          </Typography>
          <div className={classes.textfields}>
            <form onSubmit={this.handleSubmit}>
              <PasswordTextField
                passwordCallback={this.setPasswordCallback}
                password={this.state.password}
                validPasswordCallback={this.setValidPasswordCallback}
                label="New Password"
              />
            </form>
            <form onSubmit={this.handleSubmit}>
              <FormControl className={classes.inputTwo}>
                <InputLabel className={classes.labelSize}>Retype New Password</InputLabel>
                <Input
                  className={classes.inputSize}
                  type="password"
                  onChange={this.handleChangeTwo}
                  value={this.state.secondPassword}
                />
              </FormControl>
            </form>
          </div>

          <FormHelperText error className={classes.passwordMessage}>
            {this.checkPasswordsMatch()}
          </FormHelperText>
          <div>
            <Button
              className={classes.button}
              onClick={this.submitResetPassword}
              disabled={!this.checkNewPasswordCriteria()}
              classes={{ disabled: classes.disabled }}
              color="secondary"
              variant="outlined"
              type="submit"
            >
              Create your Password
            </Button>
          </div>
        </SplitPageRight>
      </SplitPageContainer>
    );
  }
}

export default withStyles(styles)(PasswordReset);
